import { ChangeDetectionStrategy, Component, DestroyRef, inject, Inject, OnInit } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { RouterOutlet } from '@angular/router';
import {
	AbstractConfigService,
	AlarisLanguageService,
	CONFIG_SERVICE_INJECTOR,
	LANGUAGE_SERVICE_INJECTOR,
} from '@campaign-portal/components-library';
import { environment } from 'src/environments/environment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DOCUMENT } from '@angular/common';
import { AlarisThemeType } from '@campaign-portal/components-library/lib/utils/providers/global/app.config.service';

const animationTiming = '1s ease-out';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: [],
	animations: [
		trigger('layoutChanged', [
			transition('SignInLayoutComponent <=> MainLayoutComponent', [
				style({ height: 0, opacity: 0 }),
				animate(animationTiming, style({ height: '*', opacity: 1 })),
			]),
		]),
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
	readonly environment = environment;
	private readonly destroyRef = inject(DestroyRef);

	constructor(
		@Inject(LANGUAGE_SERVICE_INJECTOR) private readonly lang: AlarisLanguageService,
		@Inject(CONFIG_SERVICE_INJECTOR) private readonly config: AbstractConfigService,
		@Inject(DOCUMENT) private readonly document: Document
	) {
		this.lang = lang;
	}

	ngOnInit(): void {
		this.lang.restore();
		this.config.themeType$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((type) => this.applyPrismTheme(type));
	}

	applyPrismTheme(type: AlarisThemeType): void {
		const link = this.document.getElementById('prism-theme') as HTMLLinkElement | undefined;
		if (link) {
			const theme = type === 'light' ? 'prism' : 'prism-okaidia';
			link.href = `styles/prism-theme/${theme}.min.css`;
		}
	}

	prepareRoute(outlet: RouterOutlet): boolean {
		return outlet && outlet.activatedRouteData && outlet.activatedRouteData.animationState;
	}
}
